import { render, staticRenderFns } from "./DifficultyModal.vue?vue&type=template&id=d160f7fe"
import script from "./DifficultyModal.vue?vue&type=script&lang=js"
export * from "./DifficultyModal.vue?vue&type=script&lang=js"
import style0 from "./DifficultyModal.vue?vue&type=style&index=0&id=d160f7fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports